import { createSelector } from 'reselect'
import { selectVisibleFields } from 'selectors/page'
import {
  selectRecipients,
  selectHasFromChangedInReplyDraft,
  selectHasSubjectChangedInReplyDraft,
} from 'ducks/drafts'

import { last } from 'util/arrays'

export const selectToVisible = createSelector(selectVisibleFields, visible =>
  visible.includes('to')
)

export const selectCcVisible = createSelector(
  selectRecipients,
  selectVisibleFields,
  (recipients, visible) => recipients.cc.length > 0 || visible.includes('cc')
)

export const selectBccVisible = createSelector(
  selectRecipients,
  selectVisibleFields,
  (recipients, visible) => recipients.bcc.length > 0 || visible.includes('bcc')
)

export const selectFromVisible = createSelector(
  selectVisibleFields,
  selectHasFromChangedInReplyDraft,
  (visible, hasFromChanged) => visible.includes('from') || hasFromChanged
)

export const selectPhoneVisible = createSelector(selectVisibleFields, visible =>
  visible.includes('phone')
)

export const selectSubjectVisible = createSelector(
  selectVisibleFields,
  selectHasSubjectChangedInReplyDraft,
  (visible, hasSubjectChanged) =>
    visible.includes('subject') || hasSubjectChanged
)

export const selectLastVisible = createSelector(
  selectVisibleFields,
  visible => last(visible) || ''
)

// DEPRECATED.
export const selectPendingAutofocusRow = state =>
  state.replyForm.pendingAutofocusRow
